
import _isEmpty from "lodash/isEmpty";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
	props: {
		accessory: {
			type: Object,
			default() {
				return {};
			}
		},
		type: {
			type: String,
			default() {
				return "";
			}
		}
	},
	data() {
		return {
			variantId: null,
			storage: null,
			quantity: 1
		};
	},
	computed: {
		...mapState({
			rules: state => state.PrebuildSeries.rules
		}),
		...mapGetters({
			currentAccessories: "PrebuildSeries/getCurrentAccessories",
			isCartUpdating: "PrebuildSeries/getIsCartUpdating"
		}),
		isSelected() {
			if (!_isEmpty(this.currentAccessories)) {
				return this.currentAccessories.some(({ product_id: productID }) => productID === this.accessory.id);
			}

			return false;
		},
		selectedVariantinCart() {
			if (this.isSelected && !_isEmpty(this.accessory.variants)) {
				return this.currentAccessories.find(({ product_id: productID }) => productID === this.accessory.id);
			}

			return {};
		},
		variantInCart() {
			if (this.isSelected && !_isEmpty(this.accessory.variants)) {
				return this.accessory.variants.find(({ id }) => id === this.selectedVariantinCart.variant_id);
			}

			return {};
		},
		currentVariantId() {
			if (!_isEmpty(this.accessory.variants)) {
				return this.variantId ? this.variantId : this.accessory.variants[0].id;
			}

			return this.accessory.id;
		},
		currentVariant() {
			if (!_isEmpty(this.accessory.variants)) {
				return this.accessory.variants.find(({ id }) => id === this.currentVariantId);
			}

			return this.accessory;
		},
		currentVariantImage() {
			return this.currentVariant.marketing_image || this.accessory.cover;
		},
		currentVariantPrice() {
			return this.currentVariant.price * this.quantity;
		},
		isDifferentColors() {
			return !_isEmpty(this.currentVariant.color_codes);
		},
		currentVariantColor() {
			return _isEmpty(this.currentVariant.colors) ? "" : this.currentVariant.colors[0];
		},
		showMultiselect() {
			const headset = this.currentVariant.peripheral_type === "Headset";

			return !headset;
		},
		storageOptions() {
			if (this.type === "storage") {
				return this.accessory.variants.map(({ capacity, id }) => ({ capacity, id }));
			}

			return [];
		},
		productInRules() {
			if (!_isEmpty(this.rules)) {
				return this.rules.find(item => item.products_id == this.accessory.id);
			}

			return {};
		}
	},
	watch: {
		productInRules(rule) {
			if (rule && rule.ruleType == "prevent") {
				this.quantity = 1;
			}
		}
	},
	mounted() {
		if (this.type === "storage") {
			this.storage = this.storageOptions.find(option => option.id === this.currentVariantId);
		}

		if (this.isSelected) {
			this.variantId = this.variantInCart.id;
		}

		if (!_isEmpty(this.selectedVariantinCart)) {
			this.quantity = this.selectedVariantinCart.quantity;
		}
	},
	methods: {
		...mapActions({
			updateAccessories: "PrebuildSeries/updateAccessories",
			removeAccessory: "PrebuildSeries/removeAccessory"
		}),
		storageName({ capacity }) {
			return capacity.replace(/(\.\d+)? ?/g, "");
		},
		update(variantId) {
			this.updateAccessories({
				product_id: this.accessory.id,
				variant_id: variantId,
				quantity: this.quantity
			});
		},
		remove() {
			this.removeAccessory(this.selectedVariantinCart.id);
		},
		setVariantId(variantId) {
			this.variantId = variantId;
		},
		selectStorage(variantId) {
			this.setVariantId(variantId);

			if (this.isSelected) {
				this.update(this.currentVariantId);
			}
		}
	}
};